import React, { useState } from 'react';
import rest from '../../data/restWrapper';
import translate from '@data/translations';
import useStore from '@data/state/zustand';
import { RoomInfoEditModel, SmartRoomControllerModel } from '@common/modelDefinition';
import { toast } from 'react-toastify';

interface RFIDCheckMonitoringModalProps {
    rooms: RoomInfoEditModel[];
}

const deviceKeys = ['remoteDeviceId', 'remoteDeviceId2', 'remoteDeviceId3'] as const;

const deviceKeyLabel: Record<(typeof deviceKeys)[number], string> = {
    remoteDeviceId: 'Main Controller',
    remoteDeviceId2: 'Controller 2',
    remoteDeviceId3: 'Controller 3',
};

const RFIDCheckMonitoringModal = (props: RFIDCheckMonitoringModalProps) => {
    const { rooms } = props;
    const smartRoomControllers: SmartRoomControllerModel[] = useStore((s: any) => s.model.SmartRoomController);
    const [pendingIds, setPendingIds] = useState<number[]>([]);

    const eligibleControllers = smartRoomControllers
        .filter((src) => src.remoteDeviceId && (src.srcType === null || src.srcType === 'SRC'))
        .map((src) => {
            const room = rooms.find((r: any) => deviceKeys.some((key) => r[key] === src.remoteDeviceId));
            const deviceKey = deviceKeys.find((key) => (room as any)?.[key] === src.remoteDeviceId);
            return { src, room, deviceKey };
        })
        .sort((a, b) => (a.room?.name ?? '').localeCompare(b.room?.name ?? ''));

    const toggleMonitoring = async (src: SmartRoomControllerModel) => {
        const newValue = !src.enforceDisposedRFIDCardCheckingForGeneralElectricEnabled;
        setPendingIds((prev) => [...prev, src.id]);
        try {
            await rest('SmartRoomController/' + src.id, 'PUT', {
                id: src.id,
                enforceDisposedRFIDCardCheckingForGeneralElectricEnabled: newValue,
            });
        } catch (err: any) {
            toast(err.message, { position: toast.POSITION.BOTTOM_RIGHT, type: toast.TYPE.ERROR });
        } finally {
            setPendingIds((prev) => prev.filter((id) => id !== src.id));
        }
    };

    return (
        <div className="list-wrapper-for-scroll">
            <div className="custom-list-header position-sticky-header">
                <div>{translate('Room name')}</div>
                <div>{translate('remoteDeviceId')}</div>
                <div>{translate('Monitored')}</div>
            </div>
            {eligibleControllers.map(({ src, room, deviceKey }) => (
                <div key={src.id} className="custom-list-item">
                    <div>
                        {room
                            ? deviceKey && (room.remoteDeviceId2 || room.remoteDeviceId3)
                                ? room.name + ' (' + translate(deviceKeyLabel[deviceKey]) + ')'
                                : room.name
                            : '-'}
                    </div>
                    <div>{src.remoteDeviceId}</div>
                    <div>
                        <input
                            type="checkbox"
                            disabled={pendingIds.includes(src.id)}
                            checked={!!src.enforceDisposedRFIDCardCheckingForGeneralElectricEnabled}
                            onChange={() => toggleMonitoring(src)}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RFIDCheckMonitoringModal;
